import { cx } from "@linaria/core";
import type { ReactNode } from "react";

import * as styles from "./hide-for.style";
import { Breakpoint } from "../css/maker.breakpoints";
import { units } from "../css-tokens/units";
import { useMatchMedia } from "../hooks/match-media";

type Props = {
  className?: string;

  breakpoint: Breakpoint | undefined;
  children: ReactNode;

  immediate?: boolean;
};

export function HideFor(props: Props): React.JSX.Element | null {
  const matches = useMatchMedia(props.breakpoint?.toQuery() ?? "", {
    immediate: props.immediate,
  });

  if (!props.breakpoint) {
    return <>{props.children}</>;
  }

  switch (matches) {
    case true:
      return null;

    case false:
      return (
        <div data-hide-for={false} className={props.className}>
          {props.children}
        </div>
      );

    default:
      return (
        <div
          data-hide-for={true}
          className={cx(styles.ssrContainer, props.className)}
          style={styles.tokens.__override({
            from: units.px(props.breakpoint.from ?? 0),
            to: units.px(props.breakpoint.to ?? 100000),
          })}
        >
          {props.children}
        </div>
      );
  }
}
